import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import $ from 'jquery';

const app = createApp(App);

import Header from './components/Header.vue';
app.component('Header', Header);

import Footer from './components/Footer.vue';
app.component('Footer', Footer);

window.$ = $;
window.jQuery = $;

app.use(store).use(router).mount('#app')
